import { requestPlatform, requestBase } from '@/plugins/axios'
// {password,phone,username}
export function addUser(data) {
    return requestBase({
        url: 'v1/platform/admin/create',
        method: 'POST',
        data: data
      })
}
export function showEditDialog(id) {
    return requestPlatform({
        url: `platformAdmin/getOne/${id}`,
        method: 'GET'
      })
}

// {page,size}
export function getPlatformAdminList(params) {
  return requestBase({
        url: 'v1/platform/admin/getInfo',
        method: 'GET',
        params: params
      })
}
// {userid}
export function removeFactoryById(params) {
    return requestBase({
        url: 'v1/platform/admin/del',
        method: 'POST',
        params
      })
}
